import * as ZapparBabylon from '@zappar/zappar-babylonjs';

const requestCameraPermission = () => {
    return new Promise((resolve, reject) => {
        const permissionUI = document.createElement('div');
        permissionUI.style.position = 'absolute';
        permissionUI.style.top = '0';
        permissionUI.style.left = '0';
        permissionUI.style.width = '100%';
        permissionUI.style.height = '100%';
        permissionUI.style.display = 'flex';
        permissionUI.style.alignItems = 'center';
        permissionUI.style.justifyContent = 'center';
        permissionUI.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
        permissionUI.style.zIndex = '1000';
        permissionUI.innerHTML = `
      <div style="text-align: center; color: white;">
        <p>Para visualizar a experiência com realidade aumentada, é necessário liberar a câmera do seu celular</p>
        <button id="camera-permission-allow" class="btn btn-primary w-75" style="margin: 10px;">LIBERAR ACESSO</button>
      </div>
    `;
        document.body.appendChild(permissionUI);

        const allowButton: any = document.getElementById('camera-permission-allow');

        allowButton.addEventListener('click', () => {
            document.body.removeChild(permissionUI);
            ZapparBabylon.permissionRequest().then(granted => {
                if (granted) {
                    resolve(true);
                } else {
                    reject(new Error('Permission denied'));
                }
            });
        });
    });
};

export { requestCameraPermission };
